module.exports = __webpack_public_path__ + "static/media/Juan Florez.e756e925.jpg";